import { render, staticRenderFns } from "./TransportManagement.vue?vue&type=template&id=fb9e7b50&scoped=true"
import script from "./TransportManagement.vue?vue&type=script&lang=js"
export * from "./TransportManagement.vue?vue&type=script&lang=js"
import style0 from "./TransportManagement.vue?vue&type=style&index=0&id=fb9e7b50&prod&lang=css"
import style1 from "./TransportManagement.vue?vue&type=style&index=1&id=fb9e7b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9e7b50",
  null
  
)

export default component.exports